import React from 'react';
import { PortWidget } from '@projectstorm/react-diagrams';
import { DiagramEngine } from '@projectstorm/react-diagrams';
import { S } from './MetricsNodeFactory';
import { MetricsPortModel } from './MetricsPortModel';


export class MetricsPortLabel extends React.Component<MetricsPortLabelProps> {
    render() {

        if (this.props.collapsed) {
            return null;
        }

        const port = (
            <PortWidget engine={this.props.engine} port={this.props.port}>
                <S.Port title={`[${this.props.port.getPortName()}]`} style={{ background: this.props.port.getColor() }} />
            </PortWidget>
        );
        const label = <S.Label title={`${this.props.port.getPortType()}: ${this.props.port.getDefaultValue() || ''} | [${this.props.port.getPortName()}]`}>{this.props.port.getModelName()}</S.Label>;
        if (this.props.port.properties.noPort) {
            return (
                <S.PortLabel>
                    {label}
                </S.PortLabel>
            );
        }
        return (
            <S.PortLabel style={this.props.collapsed ? { height: 0, opacity: 0, margin: 0, marginTop: 0 } : {}}>
                {this.props.port.getOptions().in ? port : label}
                {this.props.port.getOptions().in ? label : port}
            </S.PortLabel>
        );
    }
}



export interface MetricsPortLabelProps {
    port: MetricsPortModel;
    collapsed?: boolean;
    engine: DiagramEngine;
}
